import giftCard from './asda-gift-card.svg'
import giftCardCode from './asda-gift-card-code.svg'
import giftCardXmas from './asda-gift-card-xmas.svg'

export default {
  'gift-card': giftCard,
  'gift-card-code': giftCardCode,
  'gift-card-xmas': giftCardXmas,
}



// WEBPACK FOOTER //
// ./common/components/icon/gift-card/index.js